module.exports = __webpack_public_path__ + "dd83573dee49d995e654620ef0edb8fd.gif";